import React, { useState } from "react";

type JerseyProps = {
	className?: string;
	jerseyTypeAbrv?: string;
	hasOpponent?: boolean;
	hasPlaceholder?: boolean;
};

export default function JerseyIcon(props: JerseyProps) {
	const {
		className,
		jerseyTypeAbrv,
		hasOpponent,
		hasPlaceholder = false,
	} = props;

	const [imageError, setImageError] = useState<boolean>(false);

	if ((!jerseyTypeAbrv && hasOpponent) || imageError) {
		return <span className={className ? className : "u-icon--med"}></span>;
	}

	if (!jerseyTypeAbrv && hasPlaceholder) {
		return (
			<i className="u-icon u-icon--base u-icon--jersey--placeholder u-mar--right--2" />
		);
	}

	if (!jerseyTypeAbrv) {
		return null;
	}

	return (
		<img
			className={className ? className : "u-icon--med"}
			//@ts-expect-error
			loading="lazy"
			src={getJerseyIconUrl(jerseyTypeAbrv)}
			onError={() => {
				setImageError(true);
			}}
		/>
	);
}

function getJerseyIconUrl(jerseyTypeAbrv: string) {
	return `${WEBPACK_CDN_ROOT_URL}/icons/jerseys/${jerseyTypeAbrv.toLowerCase()}.svg`;
}
